import axios from "axios";
import { SET_ALERT } from "../alert"
import router from "../../router"

export default {
    actions: {
        createApproval({ commit, dispatch }, form) {
            axios
                .post("approvals", form, {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('access_token'),
                    }
                })
                .then(() => {
                    commit(SET_ALERT, {
                        message: "Confirmación registrada correctamente",
                        type: 'success'
                    });
                    dispatch("getReport", router.currentRoute.params.id);
                })
                .catch((error) => {
                    if (error.response.data) {
                        commit(SET_ALERT, {
                            message: error.response.data.message,
                            type: 'error'
                        });
                    }
                });
        },
    },
};
